import { useState } from "react";
import { InlineHelp } from "@/components/common/InlineHelp";
import { parseSenseiExportJson, translateSenseiExport } from "@/lib/ops/senseiExport";
import { importSenseiOrderIntake } from "@/lib/orderIntakeClient";

export function OpsSenseiImportSection(props: { setMsg: (s: string) => void }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const preview = (() => {
    const parsed = parseSenseiExportJson(text);
    if (!parsed.ok) return null;
    const t = translateSenseiExport(parsed.payload);
    return t.ok ? t.translation : null;
  })();

  async function submit() {
    const parsed = parseSenseiExportJson(text);
    if (!parsed.ok) {
      props.setMsg(parsed.error);
      return;
    }
    const t = translateSenseiExport(parsed.payload);
    if (!t.ok) {
      props.setMsg(t.error);
      return;
    }
    setBusy(true);
    const r = await importSenseiOrderIntake(parsed.payload);
    setBusy(false);
    if (!r.ok) {
      props.setMsg(r.error);
      return;
    }
    setText("");
    props.setMsg(
      "Sensei order landed in Pending Review. Accept it from Manufacturing → Order Intake to open the deal."
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <p className="text-xs font-medium text-gray-600">Sensei</p>
        <InlineHelp label="How Sensei import works">
          Paste-only until API permission. We store the raw JSON and only read a generic id / customer name.
        </InlineHelp>
      </div>
      <textarea
        className="w-full min-h-[6rem] rounded border border-gray-300 px-2 py-1 font-mono text-xs"
        value={text}
        disabled={busy}
        onChange={(e) => setText(e.target.value)}
        placeholder='{"id":"SN-1042","customer":{"name":"…"}}'
      />
      {preview ? (
        <p className="text-[11px] text-gray-600">
          {preview.external_source_id}
          {preview.customer_display_name ? ` · ${preview.customer_display_name}` : ""}
        </p>
      ) : null}
      <button
        type="button"
        disabled={busy}
        onClick={() => void submit()}
        className="rounded bg-indigo-600 px-3 py-1.5 text-xs text-white disabled:opacity-50"
      >
        Import to review queue
      </button>
    </div>
  );
}
